<template>
  <div class="camp-stats-section">
    <div class="camp-stats-toolbar">
      <span class="camp-stats-date">Yesterday ({{ yesterdayLabel }})</span>
      <i class="spinner fa fa-circle-o-notch fa-spin" v-if="reportLoading"></i>
    </div>

    <div class="sl-list" v-if="camp && stats">
      <ul class="sl-ul">
        <li class="sl-th">
          <span class="small-width w-span"></span>
          <span class="sortable-column id-c-1 small-width w-span-1">ID</span>
          <span class="sortable-column w-span-6">Name</span>
          <span class="sortable-column w-span-6">Status</span>
          <span class="sortable-column w-span-6">Group</span>
          <span class="sortable-column w-span-5">Requests</span>
          <span class="sortable-column w-span-5">Served</span>
          <span class="sortable-column w-span-5">Lost</span>
          <span class="sortable-column small-width w-span-1">Lost %</span>
          <span class="sortable-column w-span-4">IDFA FRQ</span>
          <span class="sortable-column w-span-4">IP FRQ</span>
          <span class="sortable-column w-span-3">Delivery FRQ</span>
          <span class="sortable-column w-span-4">SL WL / BL</span>
          <span class="sortable-column w-span-3">WL / BL</span>
          <span class="sortable-column w-span-3">AdSet Targeting</span>
          <span class="sortable-column w-span-3">Offer Targeting</span>
          <span class="sortable-column w-span-3">SL / Offer Targeting</span>
          <span class="sortable-column w-span-4">SL / Offer Paused</span>
        </li>

        <li class="sl-t sum-row">
          <span class="small-width w-span"></span>
          <span class="id-c-1 small-width w-span-1"></span>
          <span class="w-span-6"></span>
          <span class="w-span-6"></span>
          <span class="w-span-6"></span>
          <span class="w-span-5">{{ stats.total_requests | numFormat }}</span>
          <span class="w-span-5">{{ stats.served_total | numFormat }}</span>
          <span class="w-span-5">{{ stats.blocked_total | numFormat }}</span>
          <span class="small-width w-span-1">{{ stats.blocked_total_percentage | percentageFormat }}</span>
          <span class="w-span-4">{{ stats.idfa_frq_errors | numFormat }}</span>
          <span class="w-span-4">{{ stats.ip_frq_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.delivery_frq_errors | numFormat }}</span>
          <span class="w-span-4">{{ stats.sl_subs_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.offer_subs_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.adset_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.offer_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.sl_offer_errors | numFormat }}</span>
          <span class="w-span-4">{{ stats.other_errors | numFormat }}</span>
        </li>

        <li class="sl-t">
          <span @click="toggleAdsetExpand()" class="plus-td small-width w-span" v-if="stats.offers_stats && stats.offers_stats.length">
            <i aria-hidden="true" class="fa fa-plus-circle"></i>
          </span>
          <span v-else class="w-span"></span>

          <span class="po id-c-1 small-width w-span-1">{{ camp.id }}</span>
          <span class="po w-span-6">{{ camp.name }}</span>

          <span class="w-span-6">
            <b-button v-if="(groupIdActive(camp.group_id) && !camp.group_forced)" disabled size="sm">
              <span>SCHEDULE</span>
            </b-button>

            <b-button variant="danger" v-if="(groupIdActive(camp.group_id) && !camp.group_forced)" @click="toggleForceGroup(camp)" size="sm">
              <span>FORCE</span>
            </b-button>

            <button
              v-if="(camp.group_forced || camp.group_id === 0 || !groupIdActive(camp.group_id))"
              type="button"
              class="status-btn"
              :class="{ active: camp.status === 'ACTIVE', paused: camp.status === 'PAUSED' }"
              @click="toggleSlStatus(camp)"
            >
              {{ camp.status }}
            </button>

            <SlRelaunch :sl="camp" />

            <b-button variant="success" v-if="camp.group_forced" class="def-cursor" size="sm" @click="toggleForceGroup(camp)">
              <span>UNFORCE</span>
            </b-button>
          </span>

          <span id="group-cell" class="w-span-6">
            <b-form-select size="sm" v-model="camp.group_id" :options="groupList" value-field="id" text-field="name" required @change="setGroupHandler(camp)"></b-form-select>
            <div v-if="(groupIdActive(camp.group_id) && !camp.group_forced)">
              <div v-if="getGroupStatus(camp.group_id) === 'ACTIVE'" style="color: green; font-size: 10px;">
                Group is {{ getGroupStatus(camp.group_id) }}
              </div>
              <div v-if="getGroupStatus(camp.group_id) !== 'ACTIVE'" style="color: red; font-size: 10px;">
                Group is {{ getGroupStatus(camp.group_id) }}
              </div>
            </div>
          </span>

          <span class="f-s-btns-2021 w-span-5">
            <span>{{ stats.total_requests | numFormat }}</span>
            <span>
              <button v-show="userHasPermission('all-requests-report') && stats.total_requests > 0" @click="generateReport('requests')" type="button" class="btn btn-no-padding">
                <i class="fa fa-download" aria-hidden="true"></i>
              </button>
            </span>
          </span>
          <span class="w-span-5">{{ stats.served_total | numFormat }}</span>
          <span class="f-s-btns-2021 w-span-5">
            <span>{{ stats.blocked_total | numFormat }}</span>
            <span>
              <button v-show="stats.blocked_total > 0" @click="generateReport('blocked')" type="button" class="btn btn-no-padding">
                <i class="fa fa-download" aria-hidden="true"></i>
              </button>
            </span>
          </span>
          <span id="w-span-1" :class="{ alert_bad: stats.blocked_total_percentage > 20 }">{{ stats.blocked_total_percentage | percentageFormat }}</span>
          <span class="w-span-4">{{ stats.idfa_frq_errors | numFormat }}</span>
          <span class="w-span-4">{{ stats.ip_frq_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.delivery_frq_errors | numFormat }}</span>
          <span class="w-span-4">{{ stats.sl_subs_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.offer_subs_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.adset_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.offer_errors | numFormat }}</span>
          <span class="w-span-3">{{ stats.sl_offer_errors | numFormat }}</span>
          <span class="w-span-4">{{ stats.other_errors | numFormat }}</span>
        </li>

        <li class="offer-bd-li" v-for="offerStats in stats.offers_stats" v-show="offersExpanded" :key="offerStats.offer_id">
          <span class="small-width w-span"></span>
          <span class="small-width w-span-1">{{ offerStats.offer_id }}</span>
          <span class="w-span-6">{{ offerStats.offer_name }}</span>
          <span class="w-span-6">-</span>
          <span class="w-span-6">-</span>
          <span class="w-span-5">-</span>
          <span class="w-span-5">{{ offerStats.served | numFormat }}</span>
          <span class="w-span-5">-</span>
          <span class="w-span-2">-</span>
          <span class="w-span-4">-</span>
          <span class="w-span-4">-</span>
          <span class="w-span-3">-</span>
          <span class="w-span-4">-</span>
          <span class="w-span-3">-</span>
          <span class="w-span-3">-</span>
          <span class="w-span-3">-</span>
          <span class="w-span-3">-</span>
          <span class="w-span-4">-</span>
        </li>
      </ul>
    </div>

    <p v-else-if="!reportLoading" class="camp-stats-empty">No stats for yesterday.</p>
  </div>
</template>

<script>
import moment from 'moment'
import SlRelaunch from './SlRelaunch.vue'
import { confirmSlActivation } from '../utils.smartlinks'

const SL_STATUS_ACTIVE = 'ACTIVE'
const SL_STATUS_PAUSED = 'PAUSED'

const EMPTY_STATS = {
  total_requests: 0,
  served_total: 0,
  blocked_total: 0,
  blocked_total_percentage: 0,
  idfa_frq_errors: 0,
  ip_frq_errors: 0,
  delivery_frq_errors: 0,
  sl_subs_errors: 0,
  offer_subs_errors: 0,
  adset_errors: 0,
  offer_errors: 0,
  sl_offer_errors: 0,
  other_errors: 0,
  offers_stats: []
}

export default {
  components: {
    SlRelaunch
  },
  props: {
    camp: {
      required: true
    }
  },
  data() {
    return {
      reportLoading: false,
      statsLoaded: false,
      groupList: [],
      groups: [],
      approvedStatusToggle: 0,
      offersExpanded: false,
      yesterdayDate: moment().subtract(1, 'day').format('YYYY-MM-DD')
    }
  },
  computed: {
    yesterdayLabel() {
      return moment(this.yesterdayDate).format('DD.MM.YYYY')
    },
    stats() {
      if (!this.camp) {
        return null
      }
      return this.camp.new_stats || { ...EMPTY_STATS }
    }
  },
  filters: {
    numFormat(v) {
      let i = isNaN(v) ? 0 : v
      return Number(i).toLocaleString()
    },
    percentageFormat(v) {
      if (!v) {
        v = 0
      }
      return v.toFixed(0) + '%'
    }
  },
  created() {
    this.getGroupsData()
    this.loadStats()
  },
  methods: {
    async loadStats() {
      this.reportLoading = true
      try {
        const r = await this.$http.get(this.resources.SmartLinksCampaigns.getCampaigns, {
          params: {
            start_date: this.yesterdayDate,
            end_date: this.yesterdayDate,
            version: 'v2'
          }
        })
        const data = await r.json()
        const camp = data.find(item => item.id == this.camp.id)
        if (camp) {
          this.$set(this.camp, 'new_stats', camp.new_stats ? { ...camp.new_stats } : { ...EMPTY_STATS })
          if (camp.status) {
            this.camp.status = camp.status
          }
          if (camp.group_id !== undefined) {
            this.camp.group_id = camp.group_id
          }
          if (camp.group_forced !== undefined) {
            this.camp.group_forced = camp.group_forced
          }
        } else {
          this.$set(this.camp, 'new_stats', { ...EMPTY_STATS })
        }
        this.statsLoaded = true
      } catch (err) {
        this.notifyError('Could not load smartlink stats')
        this.statsLoaded = false
      } finally {
        this.reportLoading = false
      }
    },
    getGroupsData: async function () {
      try {
        const r = await this.$http.get(this.resources.SmartLinksCampaigns.getSlGroups)
        const data = await r.json()
        this.groups = data
        this.groupList = [...data]
        this.groupList.unshift({
          id: 0,
          name: 'none'
        })
      } catch (err) {
        this.notifyError('Could fetch groups.')
      }
    },
    toggleForceGroup: async function (item) {
      try {
        item.group_forced = !item.group_forced
        await this.$http.put(this.resources.SmartLinksCampaigns.setForcedCampaignStatus(item.id), {
          ...item
        })
        if (item.group_forced) {
          this.notifySuccess(`Campaign ${item.name} is no longer managed by its group scheduler`)
        } else {
          this.notifySuccess(`Campaign ${item.name} is now managed by its group scheduler`)
        }
      } catch (err) {
        item.group_forced = !item.group_forced
        this.notifyError('could not toggle force status button')
      }
    },
    groupIdActive(groupId) {
      if (groupId === 0 || groupId === undefined) {
        return false
      }
      return !!this.groups.find(x => x.id === groupId)?.isActive
    },
    getGroupStatus(groupId) {
      if (groupId === 0 || groupId === undefined) {
        return ''
      }
      for (let k in this.groups) {
        if (this.groups[k].id === groupId) {
          return this.groups[k].status
        }
      }
      return ''
    },
    toggleSlStatus(sl) {
      if (!this.userHasPermission('smartlinks.status-change')) {
        return
      }
      let toStatus
      if (sl.status === SL_STATUS_ACTIVE) {
        toStatus = SL_STATUS_PAUSED
      } else {
        toStatus = SL_STATUS_ACTIVE
      }
      if (toStatus === SL_STATUS_ACTIVE && !confirmSlActivation(sl)) {
        return
      }
      if (this.approvedStatusToggle) {
        if (!window.confirm(`Are you sure that you want to change campaign "${sl.name}" status to: ${toStatus}?`)) {
          return
        }
        this.approvedStatusToggle++
      }
      this.$http.put(this.resources.SmartLinksCampaigns.setCampaignStatus(sl.id), {
        status: toStatus
      })
        .then(() => {
          sl.status = toStatus
        })
    },
    setGroupHandler: async function (sl) {
      try {
        sl.group_forced = false
        await this.$http.put(this.resources.SmartLinksCampaigns.setCampaignGroup(sl.id), {
          group_id: sl.group_id
        })
        this.notifySuccess(`Campaign ${sl.name} group changed succesfully.`)
      } catch (err) {
        this.notifyError(`Campaign ${sl.name} group didn't change. please try again`)
      }
    },
    toggleAdsetExpand() {
      this.offersExpanded = !this.offersExpanded
    },
    generateReport: async function (type) {
      try {
        const res = await this.$http.post(this.resources.SmartLinksCampaigns.newSlRequestsBlockedReport(this.camp.id), undefined, {
          params: {
            date: this.yesterdayDate,
            end_date: this.yesterdayDate,
            request: type === 'requests' ? 'true' : 'false'
          }
        })

        if (res.ok) {
          this.notifySuccess('The report will be sent to your email when ready', 10000)
        } else {
          this.notifyError('Could not generate report')
        }
      } catch (err) {
        this.notifyError(err)
      }
    }
  }
}
</script>

<style scoped>
.camp-stats-section {
  margin-bottom: 2rem;
}

.camp-stats-toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.camp-stats-date {
  font-weight: 600;
  font-size: 14px;
}

.camp-stats-empty {
  color: #6b6b6b;
  font-size: 13px;
  margin: 0;
}

.sl-list {
  font-size: 10px;
}

.btn-no-padding {
  padding: 0;
}

.w-span {
  width: 30px;
  min-width: 10px;
  flex: none;
  padding: 4px;
}

.w-span-1 {
  width: 40px;
  min-width: 10px;
  flex: none;
  padding: 4px;
}

#w-span-1 {
  width: 40px;
  min-width: 10px;
  flex: none;
  padding: 4px;
}

.w-span-2 {
  width: 40px;
  min-width: 10px;
  flex: none;
  padding: 4px;
}

.w-span-3 {
  width: 14ch;
  min-width: 8ch;
  flex: none;
  padding: 4px;
}

.w-span-4 {
  width: 12ch;
  min-width: 6ch;
  flex: none;
  padding: 4px;
}

.w-span-5 {
  width: 16ch;
  min-width: 14ch;
  flex: none;
  padding: 4px;
}

.w-span-6 {
  width: 25ch;
  min-width: 17ch;
  flex: none;
  padding: 4px;
}
</style>
